export { FieldLabel, ToolbarField, PeriodDateRangeFields, PeriodDateRangeToolbar } from './reportFields';

export const formatReportAmount = (value: number) =>
  value === 0 ? '' : value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatReportAmountAlways = (value: number) =>
  value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const defaultPeriodDates = () => {
  const now = new Date();
  return { from: `${now.getFullYear()}-01-01`, to: now.toISOString().slice(0, 10) };
};

export type AccPeriodLike = { id: number; year: number; startDate: string; endDate: string };

export const pickDefaultAccountingPeriod = (periods: AccPeriodLike[]): AccPeriodLike | null => {
  if (periods.length === 0) return null;
  const currentYear = new Date().getFullYear();
  return periods.find((p) => p.year === currentYear) ?? periods[0];
};

export const buildExportFileName = (base: string, dateTo?: string) => {
  const suffix = dateTo ?? new Date().toISOString().slice(0, 10);
  return `${base}-${suffix}`;
};
